import { resolveEquipmentStatusFlags } from '../equipmentStatusFlags';

/**
 * Estados do card de comunicação da tela simplificada de inversor.
 * Reflete o estado de comunicação vigente do equipamento (não o de inibição/alarme).
 */
export type CommunicationCardState = 'COMMUNICATING' | 'NO_COMMUNICATION' | 'SYNCHRONIZING';

/**
 * Prevalência: Sincronizando -> Sem comunicação -> Comunicando. Inibido não é estado de comunicação
 * (o equipamento segue comunicando), então cai em `COMMUNICATING`. Aceita `status` como nome
 * (ex.: "Sincronizando - 2D5DE7") ou como bits do ETS (ex.: "110000") — ver `equipmentStatusFlags`.
 */
export const resolveCommunicationCardState = (status?: string): CommunicationCardState => {
    const flags = resolveEquipmentStatusFlags(status);
    if (flags.synchronizing) {
        return 'SYNCHRONIZING';
    }
    if (flags.withoutCommunication) {
        return 'NO_COMMUNICATION';
    }
    return 'COMMUNICATING';
};

export interface CommunicationCardContent {
    text: string;
    tone: 'success' | 'error' | 'info';
}

export const COMMUNICATION_CARD_CONTENT: Record<CommunicationCardState, CommunicationCardContent> = {
    COMMUNICATING: { text: 'Comunicando', tone: 'success' },
    NO_COMMUNICATION: { text: 'Sem comunicação', tone: 'error' },
    SYNCHRONIZING: { text: 'Sincronizando', tone: 'info' },
};
